<template>
  <div id="footerwrap">
    <div class="container">
      <div class="row copy-father">
        <div class="col-xs-12 col-md-8 text-left">
          <span class="tel">{{$t('footerTel')}} : 021-50803377</span>
          <span class="email">{{$t('footerEmail')}} : support@neucore.com</span>
          <span class="fax">{{$t('footerFax')}} : 021-50275100 · www. Neucore.com</span>
          <span class="addr">{{$t('footerAddr')}} : {{$t('footerAddrdesc')}}</span>
          <span class="copyright">
            {{$t('footerCopy')}}
            <br />
            <a href="https://beian.miit.gov.cn">{{$t('footerba')}}</a>
            <a href="/policy.html" style="margin-left:16px">隐私政策</a>
          </span>
        </div>
        <div class="col-xs-4 col-sm-2 col-md-2 text-right mobileFloat">
          <img src="img/code_pic.png" />
        </div>
        <div class="col-xs-4 col-sm-2 col-md-2 text-center mobileFloat hidden-xs-and-down" id="qrcode" ref="qrCodeUrl">
          <!-- <img src="img/code_pic.png" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import Axios from "axios";
export default {
  name: "footerBot",
  methods: {
    qrCode(url) {
      var qrDiv = document.getElementById("qrcode");
      var img = document.createElement("img");
      img.id = "qrCodeIco";
      img.src = "img/app.png";
      img.style.position = "absolute";
      img.style.width = "30px";
      img.style.height = "30px";
      //将img插入到div
      qrDiv.appendChild(img);
      let qrcode = new QRCode(this.$refs.qrCodeUrl, {
        width: 130, //图像宽度
        height: 130, //图像高度
        colorDark: "#000000", //前景色
        colorLight: "#ffffff", //背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H //容错级别 容错级别有：（1）QRCode.CorrectLevel.L （2）QRCode.CorrectLevel.M （3）QRCode.CorrectLevel.Q （4）QRCode.CorrectLevel.H
      });
      qrcode.clear(); //清除二维码
      qrcode.makeCode(url); //生成另一个新的二维码
    }
  },
  mounted() {
    this.qrCode('http://www.neuaiot.com/app_dld/');
    // Axios({
    //   method: "post",
    //   url: 'https://data.neuapi.com/v1/download'
    // })
    //   .then(res => {
    //     console.log(res)
    //     this.qrCode(res.data.data.url);
    //   })
    //   .catch(rej => {
    //     console.log(rej);
    //   });
  }
};
</script>

<style>
img {
  width: auto;
}
#qrcode img {
  margin: 0 auto;
  background: white;
  padding: 10px;
  box-sizing: border-box;
  height: 130px;
}
#qrcode #qrCodeIco {
  margin: 0 auto;
  background: white;
  padding: 0px;
  box-sizing: border-box;
  height: 160px;
}
#qrCodeIco {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -75%);
  background: white;
}
#footerwrap {
  background: #333;
  padding: 25px 0 15px 0;
  border-bottom: 1px solid #ddd;
  text-align: center;
}
#footerwrap span.copyright,
#footerwrap span.addr,
#footerwrap span.email,
#footerwrap span.fax,
#footerwrap span.tel {
  display: block;
  line-height: 30px;
  color: #888;
  font-weight: 400;
}
#footerwrap span.copyright a {
  color: #888;
}
@media screen and (max-width: 760px) {
  .copy-father {
    position: relative;
  }
  .mobileFloat {
    position: absolute !important;
    top: -132px;
    right: 0;
  }
  #footerwrap  {
      padding: 80px  0 15px 0;;
  }
  #qrcode {
      margin-right: 30px;
  }
  #qrCodeIco {
  left: 50%;
  top: 57%;
  transform: translate(-50%, -75%);
  background: white;
}
}
</style>